import React, { useState } from 'react';
import api from '../../api/axios';
import { resolveMedia } from '../../context/SettingsContext';
import toast from 'react-hot-toast';

// Generic uploader: posts to a given endpoint (field name "file") and
// returns the uploaded relative path/url via onUploaded(path).
export default function ImageUploader({ endpoint = '/uploads/image', onUploaded, currentImage, label, responseKey = 'url', hint }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentImage || '');

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await api.post(endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const path = data[responseKey] || data.logo || data.favicon;
      setPreview(path);
      onUploaded(path);
      toast.success(data.optimized ? 'Image saved as lossless WebP' : 'Image uploaded');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <label className="label">{label}</label>}
      <div className="flex items-center gap-4">
        {preview && (
          <img src={resolveMedia(preview)} alt="" className="w-16 h-16 object-cover rounded border border-primaryBrown/20" />
        )}
        <label className="btn-outline text-sm cursor-pointer">
          {uploading ? 'Uploading...' : 'Choose Image'}
          <input type="file" accept="image/*" className="hidden" onChange={handleChange} disabled={uploading} />
        </label>
      </div>
      {hint && <p className="mt-2 text-[10px] leading-4 text-[#8A796C]">{hint}</p>}
    </div>
  );
}
